import { render, staticRenderFns } from "./EmailAlertOutline.vue?vue&type=template&id=956bfb78"
import script from "./EmailAlertOutline.vue?vue&type=script&lang=js"
export * from "./EmailAlertOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports